import { Search, X } from 'lucide-react';
import { ROLE_OPTIONS, STATUS_OPTIONS, useUserFilters } from '../store/filters.store';

export function UserFilters() {
  const f = useUserFilters();
  const hasFilters = !!(f.status || f.role || f.plan || f.country || f.isVerified !== undefined || f.search);
  return (
    <div className="glass-panel rounded-xl p-4 flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-on-surface-variant" />
        <input
          value={f.search ?? ''}
          onChange={(e) => f.setFilter('search', e.target.value || undefined)}
          placeholder="Search name, email, phone, ID"
          className="w-full pl-9 pr-3 py-2 rounded-lg bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
        />
      </div>
      <Select
        label="Status"
        value={f.status ?? ''}
        options={STATUS_OPTIONS}
        onChange={(v) => f.setFilter('status', (v || undefined) as typeof f.status)}
      />
      <Select
        label="Role"
        value={f.role ?? ''}
        options={ROLE_OPTIONS}
        onChange={(v) => f.setFilter('role', (v || undefined) as typeof f.role)}
      />
      <Select
        label="Plan"
        value={f.plan ?? ''}
        options={['FREE', 'PRO', 'PREMIUM']}
        onChange={(v) => f.setFilter('plan', v || undefined)}
      />
      <Select
        label="Verified"
        value={f.isVerified === undefined ? '' : f.isVerified ? 'true' : 'false'}
        options={['true', 'false']}
        onChange={(v) => f.setFilter('isVerified', v === '' ? undefined : v === 'true')}
      />
      {hasFilters && (
        <button
          onClick={() => f.reset()}
          className="ml-auto flex items-center gap-1 text-xs text-on-surface-variant hover:text-on-surface"
        >
          <X className="w-3 h-3" /> Clear
        </button>
      )}
    </div>
  );
}

function Select({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (v: string) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-xs">
      <span className="text-on-surface-variant uppercase tracking-widest font-bold">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-2 py-1.5 rounded-md bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
      >
        <option value="">All</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </label>
  );
}
